export const GET_PASSPORT_REQUEST = "GET_PASSPORT_REQUEST";
export const GET_PASSPORT_SUCCESS = "GET_PASSPORT_SUCCESS";
export const GET_PASSPORT_FAILURE = "GET_PASSPORT_FAILURE";

export const GET_PASSPORT_DPPCODE_REQUEST = "GET_PASSPORT_DPPCODE_REQUEST";
export const GET_PASSPORT_DPPCODE_SUCCESS = "GET_PASSPORT_DPPCODE_SUCCESS";
export const GET_PASSPORT_DPPCODE_FAILURE = "GET_PASSPORT_DPPCODE_FAILURE";

export const GET_USERS_FOR_PRODUCTION_REQUEST = "GET_USERS_FOR_PRODUCTION_REQUEST";
export const GET_USERS_FOR_PRODUCTION_SUCCESS = "GET_USERS_FOR_PRODUCTION_SUCCESS";
export const GET_USERS_FOR_PRODUCTION_FAILURE = "GET_USERS_FOR_PRODUCTION_FAILURE";

export const GET_RM_TRACE_REQUEST = "GET_RM_TRACE_REQUEST";
export const GET_RM_TRACE_SUCCESS = "GET_RM_TRACE_SUCCESS";
export const GET_RM_TRACE_FAILURE = "GET_RM_TRACE_FAILURE";

export const GET_FG_OPERATION_REQUEST = "GET_FG_OPERATION_REQUEST";
export const GET_FG_OPERATION_SUCCESS = "GET_FG_OPERATION_SUCCESS";
export const GET_FG_OPERATION_FAILURE = "GET_FG_OPERATION_FAILURE";

export const GET_INDUSTRY_TYPE_REQUEST = "GET_INDUSTRY_TYPE_REQUEST";
export const GET_INDUSTRY_TYPE_SUCCESS = "GET_INDUSTRY_TYPE_SUCCESS";
export const GET_INDUSTRY_TYPE_FAILURE = "GET_INDUSTRY_TYPE_FAILURE";

export const GET_SUPPLIER_ID_REQUEST = "GET_SUPPLIER_ID_REQUEST";
export const GET_SUPPLIER_ID_SUCCESS = "GET_SUPPLIER_ID_SUCCESS";
export const GET_SUPPLIER_ID_FAILURE = "GET_SUPPLIER_ID_FAILURE";

export const GET_DPPIDS_REQUEST = "GET_DPPIDS_REQUEST";
export const GET_DPPIDS_SUCCESS = "GET_DPPIDS_SUCCESS";
export const GET_DPPIDS_FAILURE = "GET_DPPIDS_FAILURE";

export const GET_DELETE_PASSPORT_REQUEST = "GET_DELETE_PASSPORT_REQUEST";
export const GET_DELETE_PASSPORT_SUCCESS = "GET_DELETE_PASSPORT_SUCCESS";
export const GET_DELETE_PASSPORT_FAILURE = "GET_DELETE_PASSPORT_FAILURE";

export const GET_DELETE_RM_REQUEST = "GET_DELETE_RM_REQUEST";
export const GET_DELETE_RM_SUCCESS = "GET_DELETE_RM_SUCCESS";
export const GET_DELETE_RM_FAILURE = "GET_DELETE_RM_FAILURE";


export const CREATE_PASSPORT_REQUEST = "CREATE_PASSPORT_REQUEST";
export const CREATE_PASSPORT_SUCCESS = "CREATE_PASSPORT_SUCCESS";
export const CREATE_PASSPORT_FAILURE = "CREATE_PASSPORT_FAILURE";


export const CREATE_RM_REQUEST = "CREATE_RM_REQUEST";
export const CREATE_RM_SUCCESS = "CREATE_RM_SUCCESS";
export const CREATE_RM_FAILURE = "CREATE_RM_FAILURE";

export const EDIT_PASSPORT_REQUEST = "EDIT_PASSPORT_REQUEST";
export const EDIT_PASSPORT_SUCCESS = "EDIT_PASSPORT_SUCCESS";
export const EDIT_PASSPORT_FAILURE = "EDIT_PASSPORT_FAILURE";

export const EDIT_RM_REQUEST = "EDIT_RM_REQUEST";
export const EDIT_RM_SUCCESS = "EDIT_RM_SUCCESS";
export const EDIT_RM_FAILURE = "EDIT_RM_FAILURE";

export const CREATE_FG_REQUEST = "CREATE_FG_REQUEST";
export const CREATE_FG_SUCCESS = "CREATE_FG_SUCCESS";
export const CREATE_FG_FAILURE = "CREATE_FG_FAILURE";

export const GET_DELETE_FG_REQUEST = "GET_DELETE_FG_REQUEST";
export const GET_DELETE_FG_SUCCESS = "GET_DELETE_FG_SUCCESS";
export const GET_DELETE_FG_FAILURE = "GET_DELETE_FG_FAILURE";

export const EDIT_FG_REQUEST = "EDIT_FG_REQUEST";
export const EDIT_FG_SUCCESS = "EDIT_FG_SUCCESS";
export const EDIT_FG_FAILURE = "EDIT_FG_FAILURE";


export const CREATE_PRODUCT_SPEC_REQUEST = "CREATE_PRODUCT_SPEC_REQUEST";
export const CREATE_PRODUCT_SPEC_SUCCESS = "CREATE_PRODUCT_SPEC_SUCCESS";
export const CREATE_PRODUCT_SPEC_FAILURE = "CREATE_PRODUCT_SPEC_FAILURE";


export const GET_PRODUCT_SPECIFICATION_REQUEST = "GET_PRODUCT_SPECIFICATION_REQUEST";
export const GET_PRODUCT_SPECIFICATION_SUCCESS = "GET_PRODUCT_SPECIFICATION_SUCCESS";
export const GET_PRODUCT_SPECIFICATION_FAILURE = "GET_PRODUCT_SPECIFICATION_FAILURE";


export const UPLOADCSV_PRODUCT_PASSPORT_CHILD_REQUEST = "UPLOADCSV_PRODUCT_PASSPORT_CHILD_REQUEST";
export const UPLOADCSV_PRODUCT_PASSPORT_CHILD_SUCCESS = "UPLOADCSV_PRODUCT_PASSPORT_CHILD_SUCCESS";
export const UPLOADCSV_PRODUCT_PASSPORT_CHILD_FAILURE = "UPLOADCSV_PRODUCT_PASSPORT_CHILD_FAILURE";